import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { BillingInfoInput, BillingInfoUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = BillingInfoInput;
type TData = BillingInfoUpdatePayload;

export const useBillingInfoUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation billingInfoUpdate($input: BillingInfoInput!) {
      billingInfoUpdate(input: $input) {
        success
        errors
        errorCode
        billingInfo {
          firstName
          lastName
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
